import {SetFieldFn} from "../../data";
import {schedulersStyles} from "../../../styles/schedulers/schedulers.styles";
import {Box} from "@mui/material";
import SearchField from "../../SearchField";
import {useUpdateSearchParam} from "../../../hooks/useUpdateSearchParams";

export type SchedulersFilter = {
    search?: string;
    filtered?: string;
}

interface FilterTableSchedulersProps {
    search?: string;
    setField: SetFieldFn<SchedulersFilter>;
}

export default function FilterTableSchedulers({ search, setField }: FilterTableSchedulersProps) {
    const updateSearchParam = useUpdateSearchParam();

    const handleSearchChange = (searchString: string) => {
        setField("search", searchString);
        updateSearchParam("search", searchString);
    };

    return (
        <Box sx={schedulersStyles.filterTableSchedulers.box}>
            <SearchField
                value={search ?? ""}
                onChange={(searchString: string) => handleSearchChange(searchString)}
            />
        </Box>
    );
}
